// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1MC4t","inputDescription":"styles_inputDescription__3cLJH"};